/* lk-pair.js — "Pick your second frame" for the any-2 offers (26 Oct 2026, Tanishq: "if customer is pressing any 2 at
   xxxx then he should be asked to select another frame of similar size").
   Any element with data-lk-pair-open opens it:
     data-src    offer collection path; its frames come from <src>?section_id=lk-pair-data (sections/lk-pair-data)
     data-label  offer line, e.g. "Any 2 for ₹1,799"        data-size   this frame's size, "51-20-147" (may be blank)
     data-fam    optical | sun                                data-handle this frame's handle (its other colours lead)
     data-mode   pdp | cart  (pdp: after adding, offer to add this frame too; cart: reload the bag)
   Closest size first: same lens width and bridge within 3 mm counts as "similar". Frames are added as they come
   (frame only, or with fitted lenses where they ship with them); "With lenses" opens that colour's page.
   Styles: assets/lk-pair.css. */
(function () {
  'use strict';
  if (window.LKPair) return;
  var cache = {}, dlg = null, ctx = null, reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rupees(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  function parseSize(s) { var m = String(s || '').match(/(\d{2})\D+(\d{2})\D+(\d{3})/); return m ? [+m[1], +m[2], +m[3]] : null; }
  function shortTitle(t) { return String(t).replace(/\s+(Eyeglass Frame|Optical Frames?|Prescription-Friendly Optical Frame|Eyewear|Sunglasses)$/i, ''); }

  function load(src) {
    if (cache[src]) return cache[src];
    cache[src] = fetch(src + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=lk-pair-data', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (h) { var m = h.match(/data-lk-pair-json>([\s\S]*?)<\/script>/); return m ? JSON.parse(m[1]) : []; })
      .catch(function () { delete cache[src]; return []; });
    return cache[src];
  }

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'lkp lk'; /* .lk scope: the lk-btn styles live under it */
    dlg.setAttribute('aria-labelledby', 'lkp-h');
    dlg.innerHTML =
      '<div class="lkp-in">' +
        '<div class="lkp-head"><div><p class="lkp-k" data-lkp-label></p><h2 id="lkp-h">Pick your second frame</h2><p class="lkp-sub" data-lkp-sub></p></div>' +
        '<button type="button" class="lkp-x" data-lkp-close aria-label="Close">&times;</button></div>' +
        '<div class="lkp-tabs" role="tablist"><button type="button" role="tab" data-lkp-tab="near" aria-selected="true">Similar size</button><button type="button" role="tab" data-lkp-tab="all" aria-selected="false">All in this offer</button></div>' +
        '<div class="lkp-body" data-lkp-body></div>' +
        '<div class="lkp-foot" data-lkp-foot hidden></div>' +
      '</div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-lkp-close]')) { close(); return; }
      var tab = e.target.closest('[data-lkp-tab]'); if (tab) { ctx.tab = tab.getAttribute('data-lkp-tab'); render(); return; }
      var dot = e.target.closest('[data-lkp-dot]'); if (dot) { pickColour(dot); return; }
      var add = e.target.closest('[data-lkp-add]'); if (add) { addFrame(add); return; }
      var more = e.target.closest('[data-lkp-more]'); if (more) { ctx.limit += 24; render(); return; }
      var go = e.target.closest('[data-lkp-this]'); if (go) { thisFrame(go.getAttribute('data-lkp-this')); return; }
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  }

  function close() {
    if (!dlg || !dlg.open) return;
    if (reduced) { dlg.close(); return; }
    dlg.classList.add('is-out');
    setTimeout(function () { dlg.classList.remove('is-out'); dlg.close(); }, 200);
  }

  function score(ref, s) {
    if (!ref || !s) return null;
    return Math.abs(ref[0] - s[0]) + 1.5 * Math.abs(ref[1] - s[1]) + 0.1 * Math.abs(ref[2] - s[2]);
  }

  function rank(list) {
    var ref = ctx.ref, out = [];
    list.forEach(function (p) {
      if (!p.a) return;
      var vs = p.v.filter(function (v) { return v[2]; }); if (!vs.length) return;
      var s = parseSize(p.s), d = score(ref, s), same = p.h === ctx.handle;
      var near = same || (ref && s && Math.abs(ref[0] - s[0]) <= 3 && Math.abs(ref[1] - s[1]) <= 3);
      out.push({ p: p, vs: vs, s: s, d: same ? -1 : d, near: near, same: same, fam: p.f === ctx.fam });
    });
    out.sort(function (a, b) {
      if (a.same !== b.same) return a.same ? -1 : 1;
      if (a.fam !== b.fam) return a.fam ? -1 : 1;
      var da = a.d == null ? 99 : a.d, db = b.d == null ? 99 : b.d;
      return da - db;
    });
    return out;
  }

  function badge(x) {
    if (x.same) return '<span class="lkp-b is-same">Same frame</span>';
    if (x.d == null) return '<span class="lkp-b is-unk">Size not listed</span>';
    if (x.d <= 0.5) return '<span class="lkp-b is-same">Same size</span>';
    if (x.d <= 3) return '<span class="lkp-b">Very close fit</span>';
    if (x.near) return '<span class="lkp-b">Close fit</span>';
    return '';
  }

  function card(x, i) {
    var p = x.p, v = x.vs[0], pct = p.c > p.p ? Math.floor((p.c - p.p) * 100 / p.c) : 0;
    var dots = x.vs.length > 1 ? '<div class="lkp-dots" role="radiogroup" aria-label="Colour">' + x.vs.slice(0, 10).map(function (vv, k) {
      return '<button type="button" class="lkp-dot' + (k === 0 ? ' on' : '') + '" role="radio" aria-checked="' + (k === 0) + '" data-lkp-dot data-id="' + vv[0] + '" data-img="' + esc(vv[3]) + '" data-name="' + esc(vv[1]) + '" title="' + esc(vv[1]) + '">' +
        (vv[3] ? '<img src="' + esc(vv[3].replace(/width=\d+/, 'width=80')) + '" alt="" loading="lazy">' : '') + '</button>';
    }).join('') + (x.vs.length > 10 ? '<span class="lkp-more-c">+' + (x.vs.length - 10) + '</span>' : '') + '</div>' : '';
    return '<article class="lkp-card" style="--d:' + Math.min(i, 8) * 40 + 'ms" data-h="' + esc(p.h) + '" data-u="' + esc(p.u) + '" data-f="' + esc(p.f) + '" data-cg="' + (p.cg ? 1 : 0) + '">' +
      '<div class="lkp-shot"><img src="' + esc(v[3] || p.i) + '" alt="' + esc(p.t) + '" loading="lazy" data-lkp-img></div>' +
      '<div class="lkp-meta">' + badge(x) + '<p class="lkp-t">' + esc(shortTitle(p.t)) + '</p>' +
        '<p class="lkp-s">' + (x.s ? x.s.join('-') + ' mm' : '&nbsp;') + '</p>' +
        '<p class="lkp-p"><b>' + rupees(p.p) + '</b>' + (pct ? ' <s>' + rupees(p.c) + '</s>' : '') + ' <span data-lkp-cname>' + esc(x.vs.length > 1 ? v[1] : '') + '</span></p>' +
        dots +
        '<div class="lkp-acts"><button type="button" class="lk-btn lk-btn-dark lkp-add" data-lkp-add data-id="' + v[0] + '">Add frame</button>' +
        (p.np ? '' : '<a class="lkp-lens" data-lkp-lens href="' + esc(p.u) + '?variant=' + v[0] + '">With lenses</a>') + '</div>' +
      '</div></article>';
  }

  function render() {
    var body = dlg.querySelector('[data-lkp-body]');
    dlg.querySelectorAll('[data-lkp-tab]').forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-lkp-tab') === ctx.tab ? 'true' : 'false'); });
    if (!ctx.items) { body.innerHTML = '<div class="lkp-grid">' + '<div class="lkp-sk"></div>'.repeat(6) + '</div>'; return; }
    var list = ctx.tab === 'near' ? ctx.items.filter(function (x) { return x.near && x.fam; }) : ctx.items;
    var note = '';
    if (ctx.tab === 'near' && !list.length) { ctx.tab = 'all'; return render(); }
    if (!ctx.ref) note = '<p class="lkp-note">This frame’s size is not listed, so every frame in the offer is shown.</p>';
    else if (ctx.tab === 'all') note = '<p class="lkp-note">Closest to ' + ctx.ref.join('-') + ' mm first.</p>';
    body.innerHTML = note + '<div class="lkp-grid">' + list.slice(0, ctx.limit).map(card).join('') + '</div>' +
      (list.length > ctx.limit ? '<button type="button" class="lk-btn lk-btn-light lkp-morebtn" data-lkp-more>Show more frames (' + (list.length - ctx.limit) + ')</button>' : '');
    body.scrollTop = 0;
  }

  function pickColour(dot) {
    var c = dot.closest('.lkp-card'); if (!c) return;
    c.querySelectorAll('[data-lkp-dot]').forEach(function (d) { var on = d === dot; d.classList.toggle('on', on); d.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var img = c.querySelector('[data-lkp-img]'); if (img && dot.getAttribute('data-img')) img.src = dot.getAttribute('data-img');
    var nm = c.querySelector('[data-lkp-cname]'); if (nm) nm.textContent = dot.getAttribute('data-name');
    var id = dot.getAttribute('data-id');
    var add = c.querySelector('[data-lkp-add]'); if (add) add.setAttribute('data-id', id);
    var lens = c.querySelector('[data-lkp-lens]'); if (lens) lens.href = c.getAttribute('data-u') + '?variant=' + id;
  }

  function bumpBag() {
    document.querySelectorAll('[data-ee-ic="bag"]').forEach(function (a) {
      var b = a.querySelector('.lk-count');
      if (!b) { b = document.createElement('b'); b.className = 'lk-count'; b.textContent = '0'; a.appendChild(b); }
      b.textContent = (parseInt(b.textContent, 10) || 0) + 1;
      if (!reduced && b.animate) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }], { duration: 380 });
    });
  }

  function addFrame(btn) {
    var c = btn.closest('.lkp-card'), id = Number(btn.getAttribute('data-id'));
    var note = c.getAttribute('data-cg') === '1' ? 'Zero-power blue-cut lenses, fitted (included)' : (c.getAttribute('data-f') === 'sun' ? 'Sunglass lenses as shown' : 'Frame only — no lenses');
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { 'Lenses': note } }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add this frame.'); }); })
      .then(function () { return (window.LKRX && LKRX.syncAttributes) ? LKRX.syncAttributes() : null; })
      .then(function () {
        btn.textContent = 'Added ✓'; btn.classList.add('is-done'); c.classList.add('is-added');
        bumpBag();
        if (ctx.mode === 'cart') { setTimeout(function () { location.reload(); }, 450); return; }
        foot(c);
      })
      .catch(function (e) { btn.disabled = false; btn.textContent = 'Add frame'; alert((e && e.message) || 'Could not add this frame. Please try again.'); });
  }

  /* PDP: the second frame is in the bag; now this frame (with or without lenses) completes the pair */
  function foot(c) {
    var f = dlg.querySelector('[data-lkp-foot]');
    var form = document.querySelector('[data-pv2-form]');
    var btns = form ? [].slice.call(form.querySelectorAll('button')).filter(function (b) { return !b.disabled; }) : [];
    var title = c.querySelector('.lkp-t') ? c.querySelector('.lkp-t').textContent : 'Your second frame';
    f.innerHTML = '<p><b>' + esc(title) + ' is in your bag.</b> Now add this frame and the pair price applies in your bag.</p>' +
      '<div class="lkp-foot-acts">' + btns.map(function (b, i) {
        return '<button type="button" class="lk-btn ' + (i === 0 ? 'lk-btn-dark' : 'lk-btn-light') + '" data-lkp-this="' + i + '">' + esc(b.getAttribute('data-label') || b.textContent.trim()) + '</button>';
      }).join('') + '<a class="lkp-bag" href="/cart">Go to bag</a></div>';
    f.hidden = false;
    if (!reduced) f.animate && f.animate([{ transform: 'translateY(100%)' }, { transform: 'none' }], { duration: 280, easing: 'cubic-bezier(.22,.61,.36,1)' });
  }
  function thisFrame(i) {
    var form = document.querySelector('[data-pv2-form]');
    var btns = form ? [].slice.call(form.querySelectorAll('button')).filter(function (b) { return !b.disabled; }) : [];
    close();
    var b = btns[+i]; if (b) setTimeout(function () { b.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' }); b.click(); }, 260);
  }

  function open(el) {
    if (!dlg) build();
    var d = el.dataset;
    ctx = { src: d.src, mode: d.mode || 'pdp', handle: d.handle || '', fam: d.fam || 'optical', ref: parseSize(d.size), tab: 'near', limit: 24, items: null };
    dlg.querySelector('[data-lkp-label]').textContent = d.label || '';
    dlg.querySelector('[data-lkp-sub]').textContent = ctx.ref
      ? 'Closest to this frame’s size first (' + ctx.ref.join('-') + ' mm: lens, bridge, temple).'
      : 'Pick any frame in this offer; the pair price applies in your bag.';
    dlg.querySelector('[data-lkp-foot]').hidden = true;
    render();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    load(ctx.src).then(function (list) { ctx.items = rank(list); render(); });
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lk-pair-open]');
    if (!o || !o.getAttribute('data-src') || !window.HTMLDialogElement) return;
    e.preventDefault();
    open(o);
  });
  /* warm the data when the shopper is about to tap */
  document.addEventListener('pointerover', function (e) { var o = e.target.closest && e.target.closest('[data-lk-pair-open]'); if (o && o.getAttribute('data-src')) load(o.getAttribute('data-src')); }, { passive: true });

  window.LKPair = { open: open };
})();
